<template>
  <div class="d-flex flex-column flex-lg-row min-vh-100 bg-light">
    <Sidebar
      :class="{ 'd-none d-lg-flex': !sidebarOpen }"
      @close-sidebar="sidebarOpen = false"
    />

    <div class="main-content">
      <Header @toggle-sidebar="sidebarOpen = !sidebarOpen" />

      <main class="container-fluid p-4">
        <!-- CARGANDO -->
        <div v-if="loading" class="text-center py-5">
          <div class="spinner-border text-primary" role="status"></div>
        </div>

        <!-- ERROR -->
        <div v-if="error" class="alert alert-danger alert-dismissible fade show">
          <i class="bi bi-exclamation-triangle me-2"></i>
          {{ error }}
          <button type="button" class="btn-close" @click="error = null"></button>
        </div>

        <!-- MENSAJE OK -->
        <div v-if="mensaje" class="alert alert-success alert-dismissible fade show">
          <i class="bi bi-check-circle me-2"></i>
          {{ mensaje }}
          <button type="button" class="btn-close" @click="mensaje = null"></button>
        </div>

        <!-- CONTENIDO -->
        <div v-if="!loading" class="mod-container">
          <div class="mod-header">
            <div>
              <h2>Configuración · Módulos</h2>
              <p>Da de alta, edita, activa/desactiva y organiza los módulos del menú.</p>
            </div>

            <div class="d-flex gap-2">
              <button type="button" class="btn-sec" @click="abrirNuevo(true)">
                <i class="bi bi-folder-plus"></i> Nuevo grupo
              </button>
              <button type="button" class="btn-nuevo" @click="abrirNuevo(false)">
                <i class="bi bi-plus-lg"></i> Nuevo submódulo
              </button>
            </div>
          </div>

          <div class="mod-content">
            <table class="mod-table">
              <thead>
                <tr>
                  <th style="width:70px">Orden</th>
                  <th>Módulo</th>
                  <th>Ruta</th>
                  <th style="width:110px" class="text-center">Estado</th>
                  <th style="width:150px" class="text-center">Acciones</th>
                </tr>
              </thead>

              <tbody>
                <template v-for="row in filas" :key="row.id">
                  <tr :class="row._tipo === 'grupo' ? 'fila-grupo' : 'fila-sub'">
                    <td class="text-center text-muted">{{ row.orden }}</td>

                    <td>
                      <div class="mod-info" :class="{ 'ps-4': row._tipo === 'sub' }">
                        <i :class="(row.icono || (row._tipo==='grupo' ? 'bi bi-folder' : 'bi bi-dot')) + ' mod-icon'"></i>
                        <div>
                          <div class="mod-title">
                            {{ row.titulo || row.nombre }}
                            <span v-if="row._tipo === 'grupo'" class="badge-grupo">Grupo</span>
                          </div>
                          <div class="mod-clave">{{ row.nombre }}</div>
                        </div>
                      </div>
                    </td>

                    <td class="text-muted">{{ row.ruta || '—' }}</td>

                    <td class="text-center">
                      <button
                        type="button"
                        class="badge-estado"
                        :class="row.activo ? 'on' : 'off'"
                        @click="toggleActivo(row)"
                        :title="row.activo ? 'Clic para desactivar' : 'Clic para activar'"
                      >
                        <i :class="row.activo ? 'bi bi-check-circle' : 'bi bi-slash-circle'"></i>
                        {{ row.activo ? 'Activo' : 'Inactivo' }}
                      </button>
                    </td>

                    <td>
                      <div class="acciones">
                        <button type="button" class="btn-action btn-edit" @click="abrirEditar(row)" title="Editar">
                          <i class="bi bi-pencil"></i>
                        </button>
                        <button type="button" class="btn-action btn-delete" @click="pedirEliminar(row)" title="Eliminar">
                          <i class="bi bi-trash"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                </template>

                <tr v-if="filas.length === 0">
                  <td colspan="5">
                    <div class="empty-state">
                      <i class="bi bi-diagram-3"></i>
                      <h5>No hay módulos</h5>
                      <span>Crea un grupo y luego sus submódulos.</span>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </main>
    </div>

    <div v-if="sidebarOpen" class="sidebar-overlay d-lg-none" @click="sidebarOpen = false"></div>

    <!-- MODAL CREAR/EDITAR -->
    <BaseModal v-model:visible="modalVisible" :title="modalTitle">
      <div class="row g-3">
        <div class="col-12">
          <label class="form-label">Tipo</label>
          <select v-model="form.esGrupo" class="form-select" :disabled="!!editingId">
            <option :value="true">Grupo (sección del menú)</option>
            <option :value="false">Submódulo (página)</option>
          </select>
        </div>

        <div class="col-md-6">
          <label class="form-label">Título (visible)</label>
          <input v-model="form.titulo" type="text" class="form-control" placeholder="Ej. Roles y permisos" />
        </div>

        <div class="col-md-6">
          <label class="form-label">Clave interna (única)</label>
          <input v-model="form.nombre" type="text" class="form-control" placeholder="Ej. roles" />
          <small class="text-muted">Sin espacios. Se usa para permisos.</small>
        </div>

        <div v-if="!form.esGrupo" class="col-md-6">
          <label class="form-label">Grupo padre</label>
          <select v-model="form.parent_id" class="form-select">
            <option :value="null" disabled>Selecciona un grupo…</option>
            <option v-for="g in grupos" :key="g.id" :value="g.id">
              {{ g.titulo || g.nombre }}
            </option>
          </select>
        </div>

        <div v-if="!form.esGrupo" class="col-md-6">
          <label class="form-label">Ruta (link)</label>
          <input v-model="form.ruta" type="text" class="form-control" placeholder="Ej. /usuarios/roles" />
        </div>

        <div class="col-md-6">
          <label class="form-label">Ícono</label>
          <div class="input-group">
            <span class="input-group-text"><i :class="form.icono || 'bi bi-dot'"></i></span>
            <input v-model="form.icono" type="text" class="form-control" placeholder="bi bi-gear" />
          </div>
          <small class="text-muted">Clase de Bootstrap Icons.</small>
        </div>

        <div v-if="!form.esGrupo" class="col-md-3">
          <label class="form-label">Acción (ver)</label>
          <select v-model="form.accion" class="form-select">
            <option value="listar">listar</option>
            <option value="crear">crear</option>
            <option value="actualizar">actualizar</option>
            <option value="eliminar">eliminar</option>
          </select>
        </div>

        <div class="col-md-3">
          <label class="form-label">Orden</label>
          <input v-model.number="form.orden" type="number" class="form-control" min="0" />
        </div>

        <div class="col-12">
          <div class="form-check form-switch">
            <input v-model="form.activo" class="form-check-input" type="checkbox" id="activoChk" />
            <label class="form-check-label" for="activoChk">Activo</label>
          </div>
        </div>
      </div>

      <template #footer>
        <button type="button" class="btn btn-secondary" @click="modalVisible = false">Cancelar</button>
        <button type="button" class="btn btn-primary" @click="guardar">
          {{ editingId ? 'Actualizar' : 'Guardar' }}
        </button>
      </template>
    </BaseModal>

    <!-- CONFIRMAR ELIMINAR -->
    <ConfirmModal
      v-model:visible="confirmVisible"
      :message="confirmMessage"
      @confirmed="confirmarEliminar"
    />
  </div>
</template>

<script>
import { ref, computed, onMounted } from 'vue';
import api from '@/services/api.js';
import Header from '@/components/HeaderVue.vue';
import Sidebar from '@/components/Sidebar.vue';
import BaseModal from '@/components/BaseModal.vue';
import ConfirmModal from '@/components/ConfirmModal.vue';

export default {
  name: 'ModulosViews',

  components: { Header, Sidebar, BaseModal, ConfirmModal },

  setup() {
    const sidebarOpen = ref(false);
    const modulos = ref([]);
    const loading = ref(false);
    const error = ref(null);
    const mensaje = ref(null);

    const modalVisible = ref(false);
    const modalTitle = ref('');
    const editingId = ref(null);

    const form = ref({
      esGrupo: false,
      nombre: '',
      titulo: '',
      parent_id: null,
      ruta: '',
      icono: '',
      accion: 'listar',
      orden: 0,
      activo: true,
    });

    const confirmVisible = ref(false);
    const confirmMessage = ref('');
    const eliminarId = ref(null);

    // Grupos (parent_id null) para el select
    const grupos = computed(() =>
      modulos.value
        .filter((m) => m.parent_id === null)
        .sort((a, b) => a.orden - b.orden)
    );

    // Filas en orden de árbol: grupo seguido de sus submódulos
    const filas = computed(() => {
      const out = [];
      grupos.value.forEach((g) => {
        out.push({ ...g, _tipo: 'grupo' });
        modulos.value
          .filter((m) => m.parent_id === g.id)
          .sort((a, b) => a.orden - b.orden)
          .forEach((h) => out.push({ ...h, _tipo: 'sub' }));
      });
      return out;
    });

    const cargar = async () => {
      loading.value = true;
      error.value = null;
      try {
        const res = await api.get('/modulos');
        modulos.value = res.data || [];
      } catch (e) {
        error.value = 'Error al cargar los módulos: ' + (e.response?.data?.message || e.message);
      } finally {
        loading.value = false;
      }
    };

    const abrirNuevo = (esGrupo) => {
      editingId.value = null;
      modalTitle.value = esGrupo ? 'Nuevo grupo' : 'Nuevo submódulo';
      form.value = {
        esGrupo,
        nombre: '',
        titulo: '',
        parent_id: esGrupo ? null : (grupos.value[0]?.id ?? null),
        ruta: '',
        icono: esGrupo ? 'bi bi-folder' : '',
        accion: 'listar',
        orden: 0,
        activo: true,
      };
      modalVisible.value = true;
    };

    const abrirEditar = (row) => {
      editingId.value = row.id;
      modalTitle.value = 'Editar módulo';
      form.value = {
        esGrupo: row.parent_id === null,
        nombre: row.nombre || '',
        titulo: row.titulo || '',
        parent_id: row.parent_id ?? null,
        ruta: row.ruta || '',
        icono: row.icono || '',
        accion: row.accion || 'listar',
        orden: row.orden ?? 0,
        activo: !!row.activo,
      };
      modalVisible.value = true;
    };

    const guardar = async () => {
      const f = form.value;

      if (!f.nombre.trim()) {
        error.value = 'La clave interna es obligatoria.';
        return;
      }
      if (!f.esGrupo && !f.parent_id) {
        error.value = 'Un submódulo requiere un grupo padre.';
        return;
      }
      if (!f.esGrupo && !f.ruta.trim()) {
        error.value = 'Un submódulo requiere una ruta.';
        return;
      }

      const payload = {
        nombre: f.nombre.trim(),
        titulo: f.titulo.trim() || f.nombre.trim(),
        icono: f.icono.trim() || null,
        orden: f.orden || 0,
        activo: f.activo,
        parent_id: f.esGrupo ? null : f.parent_id,
        ruta: f.esGrupo ? null : f.ruta.trim(),
        accion: f.esGrupo ? 'listar' : f.accion,
      };

      loading.value = true;
      error.value = null;
      try {
        if (editingId.value) {
          await api.put(`/modulos/${editingId.value}`, payload);
          mensaje.value = 'Módulo actualizado correctamente.';
        } else {
          await api.post('/modulos', payload);
          mensaje.value = 'Módulo creado correctamente.';
        }
        modalVisible.value = false;
        await cargar();
      } catch (e) {
        error.value = 'Error al guardar: ' + (e.response?.data?.message || e.message);
      } finally {
        loading.value = false;
      }
    };

    const toggleActivo = async (row) => {
      try {
        await api.patch(`/modulos/${row.id}/toggle`);
        await cargar();
      } catch (e) {
        error.value = 'Error al cambiar el estado: ' + (e.response?.data?.message || e.message);
      }
    };

    const pedirEliminar = (row) => {
      eliminarId.value = row.id;
      confirmMessage.value =
        row.parent_id === null
          ? `¿Eliminar el grupo "${row.titulo || row.nombre}"? Sus submódulos quedarán sin grupo.`
          : `¿Eliminar el módulo "${row.titulo || row.nombre}"?`;
      confirmVisible.value = true;
    };

    const confirmarEliminar = async () => {
      if (!eliminarId.value) return;
      loading.value = true;
      error.value = null;
      try {
        await api.delete(`/modulos/${eliminarId.value}`);
        mensaje.value = 'Módulo eliminado.';
        await cargar();
      } catch (e) {
        error.value = 'Error al eliminar: ' + (e.response?.data?.message || e.message);
      } finally {
        loading.value = false;
        eliminarId.value = null;
        confirmVisible.value = false;
      }
    };

    onMounted(cargar);

    return {
      sidebarOpen,
      modulos,
      loading,
      error,
      mensaje,
      grupos,
      filas,
      modalVisible,
      modalTitle,
      editingId,
      form,
      confirmVisible,
      confirmMessage,
      abrirNuevo,
      abrirEditar,
      guardar,
      toggleActivo,
      pedirEliminar,
      confirmarEliminar,
    };
  },
};
</script>

<style scoped>
.main-content {
  flex: 1;
  margin-top: 60px;
}

@media (min-width: 992px) {
  .main-content {
    margin-left: 250px;
  }
}

main {
  min-height: calc(100vh - 60px);
}

.mod-container {
  background: #fff;
  border-radius: 24px;
  overflow: hidden;
  box-shadow: 0 15px 40px rgba(0, 0, 0, .05);
  border: 1px solid #edf0f5;
}

.mod-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
  padding: 28px;
  border-bottom: 1px solid #edf0f5;
}

.mod-header h2 {
  font-size: 22px;
  font-weight: 700;
  margin: 0;
}

.mod-header p {
  margin: 5px 0 0;
  color: #6b7280;
}

.btn-nuevo,
.btn-sec {
  border: none;
  padding: 11px 18px;
  border-radius: 12px;
  font-weight: 600;
  display: flex;
  gap: 8px;
  align-items: center;
}

.btn-nuevo {
  background: #2563eb;
  color: #fff;
}

.btn-sec {
  background: #eef2f6;
  color: #344054;
}

.btn-nuevo:hover,
.btn-sec:hover {
  opacity: .9;
}

.mod-content {
  padding: 16px 20px 24px;
  overflow-x: auto;
}

.mod-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0 8px;
}

.mod-table thead th {
  color: #64748b;
  font-size: 12.5px;
  font-weight: 700;
  text-transform: uppercase;
  padding: 0 16px 8px;
  text-align: left;
}

.fila-grupo td {
  background: #eef2f6;
  padding: 12px 16px;
}

.fila-grupo td:first-child {
  border-radius: 12px 0 0 12px;
}

.fila-grupo td:last-child {
  border-radius: 0 12px 12px 0;
}

.fila-sub td {
  background: #f8fafc;
  padding: 12px 16px;
}

.fila-sub td:first-child {
  border-radius: 12px 0 0 12px;
}

.fila-sub td:last-child {
  border-radius: 0 12px 12px 0;
}

.mod-info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.mod-icon {
  font-size: 18px;
  color: #0B5EA8;
  width: 22px;
  text-align: center;
}

.mod-title {
  font-weight: 600;
  color: #111827;
  display: flex;
  align-items: center;
  gap: 8px;
}

.mod-clave {
  font-size: 12px;
  color: #94a3b8;
}

.badge-grupo {
  background: #dbeafe;
  color: #1d4ed8;
  font-size: 11px;
  font-weight: 700;
  padding: 2px 8px;
  border-radius: 999px;
}

.badge-estado {
  border: none;
  border-radius: 999px;
  padding: 6px 12px;
  font-size: 12.5px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
}

.badge-estado.on {
  background: #dcfce7;
  color: #15803d;
}

.badge-estado.off {
  background: #fee2e2;
  color: #b91c1c;
}

.acciones {
  display: flex;
  justify-content: center;
  gap: 10px;
}

.btn-action {
  width: 40px;
  height: 40px;
  border: none;
  border-radius: 12px;
  transition: .3s;
}

.btn-edit {
  background: #fef3c7;
  color: #d97706;
}

.btn-delete {
  background: #fee2e2;
  color: #dc2626;
}

.btn-action:hover {
  transform: translateY(-2px);
}

.empty-state {
  padding: 48px;
  text-align: center;
}

.empty-state i {
  font-size: 56px;
  color: #cbd5e1;
}

.empty-state h5 {
  margin-top: 14px;
  font-weight: 700;
}

.empty-state span {
  color: #64748b;
}
</style>
